import { Box } from 'rebass/styled-components'
import styled from 'styled-components/macro'

const Card = styled(Box)<{ width?: string; padding?: string; border?: string; $borderRadius?: string }>`
  width: ${({ width }) => width ?? '100%'};
  padding: ${({ padding }) => padding ?? '1rem'};
  border-radius: ${({ $borderRadius }) => $borderRadius ?? '5px'};
  border: ${({ border }) => border ?? '1px'};
`
export default Card

export const LightCard = styled(Card)`
  border: 2px solid ${({ theme }) => theme.bg5};
  background-color: ${({ theme }) => theme.bg6};
`

export const LightGreyCard = styled(Card)`
  background-color: ${({ theme }) => theme.bg5};
`

export const GreyCard = styled(Card)`
  background-color: ${({ theme }) => theme.bg3};
`

export const DarkGreyCard = styled(Card)`
  background-color: ${({ theme }) => theme.bg1};
`

export const DarkCard = styled(Card)`
  background-color: ${({ theme }) => theme.bg0};
`

export const BlackCard = styled(Card)`
  background-color: ${({ theme }) => theme.modalBG};
`

export const OutlineCard = styled(Card)`
  border: 1px solid ${({ theme }) => theme.bg2};
`

export const YellowCard = styled(Card)`
  background-color: rgba(243, 132, 30, 0.05);
  color: ${({ theme }) => theme.yellow3};
  font-weight: 400;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
  border-radius: 3px;
`

export const BlueCard = styled(Card)`
  color: ${({ theme }) => theme.text1};
  background-color: ${({ theme }) => theme.bg1};
  border-radius: 0px;
  margin-bottom: 2rem;
  box-shadow: rgba(0, 0, 0, 0.45) 0px 25px 20px -20px, rgba(0, 0, 0, 0.45) 0px -25px 20px -20px;
  backdrop-filter: blur(50px);
  -webkit-backdrop-filter: blur(6.3px);
`
